module.exports = __webpack_public_path__ + "static/media/bk-menu-active.3d21dbb2.png";